document.addEventListener('DOMContentLoaded', () => {
    const newsletterForm = document.getElementById('newsletter-form');

    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function (e) {
            e.preventDefault();
            const inputEl = this.querySelector('input[name="email"]');
            const email = inputEl.value;
            const messageEl = document.getElementById('newsletter-message');
            const submitBtn = this.querySelector('button[type="submit"]');
            const actionUrl = this.getAttribute('data-action');

            if (!email) {
                messageEl.textContent = 'Por favor, insira um email vÃ¡lido.';
                messageEl.className = 'newsletter-message error';
                messageEl.hidden = false;
                return;
            }

            const originalBtnText = submitBtn.innerHTML;
            submitBtn.innerHTML = 'Enviando...';
            submitBtn.disabled = true;

            const formData = new FormData();
            formData.append('email', email);

            fetch(actionUrl, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    submitBtn.innerHTML = originalBtnText;
                    submitBtn.disabled = false;

                    messageEl.textContent = data.message;
                    messageEl.className = 'newsletter-message ' + data.status;
                    messageEl.hidden = false;

                    if (data.status === 'success') {
                        inputEl.value = '';
                    }

                    setTimeout(() => {
                        messageEl.hidden = true;
                    }, 6000);
                })
                .catch(() => {
                    submitBtn.innerHTML = originalBtnText;
                    submitBtn.disabled = false;

                    messageEl.textContent = 'Erro de conexÃ£o. Tente novamente mais tarde.';
                    messageEl.className = 'newsletter-message error';
                    messageEl.hidden = false;

                    setTimeout(() => {
                        messageEl.hidden = true;
                    }, 6000);
                });
        });
    }
});
